import { Box, Stack, Typography, useTheme } from "@mui/material";

export interface ActivityLegendItem {
  label: string;
  /** Optional because every primitive palette shade is typed optional. */
  color?: string;
}

interface ActivityLegendProps {
  items: ActivityLegendItem[];
  /** `square` matches the bar charts, `dot` the metric lists. */
  marker?: "square" | "dot";
}

/**
 * Wrapping legend rendered outside the chart. The chart components ship their
 * own recharts `<Legend>`, but it can't wrap or share a row with other content,
 * so every Activity card turns it off and uses this instead.
 */
export const ActivityLegend = ({
  items,
  marker = "square",
}: ActivityLegendProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      sx={{ flexWrap: "wrap", rowGap: "8px", columnGap: "16px" }}
    >
      {items.map((item) => (
        <Stack
          key={item.label}
          direction="row"
          sx={{ alignItems: "center", gap: "6px", minWidth: 0 }}
        >
          <Box
            sx={{
              flexShrink: 0,
              width: marker === "dot" ? "8px" : "10px",
              height: marker === "dot" ? "8px" : "10px",
              borderRadius: marker === "dot" ? "50%" : "2px",
              backgroundColor: item.color,
            }}
          />
          <Typography
            variant="body-xsmall"
            sx={{ color: theme.palette.lightBg.low }}
            noWrap
          >
            {item.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
